module.exports = {
  mode: {
    time: 'mode.time',
    training: 'mode.training',
  },
  game: {
    card: 'game.card',
    image: 'game.image',
    number: 'game.number',
  },
};



// WEBPACK FOOTER //
// ./src/game.js